export const BASE_URL = "https://backoffice.arboutiqueapartments.it"
export const AUTH_URL = '/auth/local'
export const GRAPHQL_URL = '/graphql'